import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const DashboardPage = lazy(() =>
  import('@/pages/ads/dashboard/dashboard-page').then((m) => ({ default: m.DashboardPage })),
);

export const Route = createFileRoute('/_app/ads/dashboard')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:dashboard', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <DashboardPage />
    </Suspense>
  ),
});
